const subAbas = [
  { label: 'Usuários', rota: '/secsaude/adm/usuarios' },
  { label: 'Acessos', rota: '/secsaude/adm/acessos' },
  { label: 'Logs', rota: '/secsaude/adm/logs' },
  { label: 'Histórico de RT', rota: '/secsaude/adm/historicodert' },
  {
    label: 'Histórico de Vinculações',
    rota: '/secsaude/adm/historicodevinculacoes',
  },

  /*{ label: 'Relatórios', rota: '/daf/adm/relatorios' },*/
];

export default subAbas;
